import { Filter } from '@ami/react/core';

export class ProductGroupFilter extends Filter {
  constructor(filter) {
    super(filter);
    if (filter) {
      this.name = filter.name;
      this.productCategoryId = filter.productCategoryId;
      this.carrierId = filter.carrierId;    
      this.exceptProductGroupIds = filter.exceptProductGroupIds;
      this.visibility = filter.visibility;
      this.type = filter.type;
      return this;
    }
    this.name = '';
    this.productCategoryId = '';
    this.carrierId = '';
    this.exceptProductGroupIds = null;
    this.visibility = null;
    this.type = null;
  }
}
